import { render, staticRenderFns } from "./ShowTaskItem.vue?vue&type=template&id=1b5dbc74&scoped=true"
import script from "./ShowTaskItem.vue?vue&type=script&lang=js"
export * from "./ShowTaskItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5dbc74",
  null
  
)

export default component.exports